import jsonConfig from "./config.json";

const ENV = process.env.REACT_APP_ENV || process.env.ENV;
const SERVER_URL = ENV === "DEVELOPMENT"
  ? "http://localhost:8000"
  : process.env.REACT_APP_SERVER_URL || jsonConfig.SERVER_URL || "http://localhost:8000";

export default {
  SERVER_URL,
};
